import Slider from "./_slider";

[...document.querySelectorAll('.js-slider')].map((element) => {
    const slider = new Slider(element);
})
